{
  "menu": {
    "label": "Akaun",
    "organisation": "Organisasi",
    "sessions": "Peranti dan sesi",
    "signOut": "Log keluar",
    "signingOut": "Sedang log keluar"
  },
  "sessions": {
    "title": "Peranti dan sesi",
    "description": "Setiap tempat akaun ini telah log masuk. Batalkan mana-mana yang anda tidak kenal — ia berhenti berfungsi pada permintaan seterusnya, bukan pada log masuk seterusnya.",
    "loading": "Memuatkan sesi anda",
    "empty": {
      "title": "Tiada sesi lain",
      "description": "Ini sahaja peranti yang log masuk ke akaun ini."
    },
    "current": "Peranti ini",
    "remembered": "Kekal log masuk",
    "lastActive": "Aktif terakhir {{when}}",
    "expires": "Tamat tempoh {{when}}",
    "unknownDevice": "Pelayar tidak dikenali",
    "unknownIp": "Tiada alamat direkodkan",
    "device": "{{browser}} pada {{platform}}",
    "revoke": "Batalkan",
    "revoking": "Sedang membatalkan",
    "revokeLabel": "Batalkan sesi pada {{device}}",
    "revokeOthers": "Log keluar di tempat lain",
    "revokeOthersConfirm": {
      "title": "Log keluar di tempat lain?",
      "description": "Setiap peranti lain akan dilog keluar pada permintaan seterusnya. Peranti ini kekal log masuk.",
      "confirm": "Log keluar yang lain",
      "close": "Tutup"
    },
    "revokedOthers": "Telah log keluar daripada {{count}} sesi lain.",
    "revokedOthers_other": "Telah log keluar daripada {{count}} sesi lain.",
    "revokedOthersNone": "Tiada apa-apa lagi yang log masuk.",
    "gone": {
      "title": "Sesi itu telah pun tamat",
      "description": "Ia dibatalkan di tempat lain, atau telah tamat tempoh. Senarai di bawah adalah terkini."
    }
  }
}
